
































import { Vue, Component } from 'vue-property-decorator';
import XGplayer from '@/components/XGplayer.vue';
import { Swipe, SwipeItem, Lazyload, ImagePreview } from 'vant';
import VoteButton from '../components/VoteButton.vue';
import { getDetail } from '../api';
Vue.use(Swipe).use(SwipeItem).use(Lazyload).use(ImagePreview);

@Component({
  components: { XGplayer, VoteButton },
})
export default class Detail extends Vue {
  object: any = {};
  type: any = '';
  voteName: string = '2021project/q4/2021beautiful';
  images: any = [
    'https://img01.yzcdn.cn/vant/apple-1.jpg',
    'https://img01.yzcdn.cn/vant/apple-2.jpg',
  ];

  async created() {
    const res = await getDetail(this.$route.query.id);
    this.object = res.data;
    this.type = this.$route.query.workType;
  }
  getImg(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
  votSuccess(data: any, index: any) {
    this.object.votes = data;
  }
}
